var render = function () {
  var _vm$paySlipData, _vm$paySlipData2, _vm$paySlipData2$viol, _vm$paySlipData2$viol2, _vm$paySlipData3, _vm$paySlipData4, _vm$paySlipData5, _vm$paySlipData6, _vm$paySlipData7, _vm$paySlipData8, _vm$paySlipData9, _vm$paySlipData10, _vm$paySlipData11, _vm$paySlipData12, _vm$paySlipData13, _vm$paySlipData14;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('div', {
    staticClass: "offset-md-1 col-md-10 col-lg-10"
  }, [_c('validation-observer', {
    ref: "payslipValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.payslipValidationForm($event);
      }
    }
  }, [_c('user-info-card', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "user-data": _vm.userData,
      "payslip": _vm.paySlipData
    }
  }), ((_vm$paySlipData = _vm.paySlipData) === null || _vm$paySlipData === void 0 ? void 0 : _vm$paySlipData.salary_type) !== 'monthly' && (_vm$paySlipData2 = _vm.paySlipData) !== null && _vm$paySlipData2 !== void 0 && (_vm$paySlipData2$viol = _vm$paySlipData2.violationRules) !== null && _vm$paySlipData2$viol !== void 0 && (_vm$paySlipData2$viol2 = _vm$paySlipData2$viol.data) !== null && _vm$paySlipData2$viol2 !== void 0 && _vm$paySlipData2$viol2.length ? _c('b-card-actions', {
    attrs: {
      "title": " ⚠️ Violated Rules",
      "collapsed": true,
      "action-collapse": ""
    }
  }, [_c('div', {
    staticClass: "overflow-scroll",
    staticStyle: {
      "height": "350px"
    }
  }, [_vm._l(_vm.paySlipData.violationRules.data, function (violation, index) {
    var _violation$rule, _violation$rule$data, _violation$rule2, _violation$rule2$data, _violation$rule3, _violation$rule3$data, _violation$rule4, _violation$rule4$data, _violation$rule5, _violation$rule5$data, _violation$rule$data$, _violation$rule6, _violation$rule6$data;
    return _c('div', {
      key: index,
      staticClass: "alert alert-warning mb-3 p-3"
    }, [_c('p', {
      staticClass: "mb-1"
    }, [_c('strong', [_vm._v("⚠️ Policy Violation Notice")])]), _c('p', {
      staticClass: "mb-1"
    }, [_c('strong', [_vm._v("Period:")]), _vm._v(" " + _vm._s(_vm.formatDate(violation.start_date)) + " – " + _vm._s(_vm.formatDate(violation.end_date)) + " (Cycle: " + _vm._s((_violation$rule = violation.rule) === null || _violation$rule === void 0 ? void 0 : (_violation$rule$data = _violation$rule.data) === null || _violation$rule$data === void 0 ? void 0 : _violation$rule$data.cycle_in_days) + " days) ")]), _c('p', {
      staticClass: "mb-1"
    }, [_c('strong', [_vm._v("Worked Hours:")]), _vm._v(" " + _vm._s(violation.total_work_hours) + " hours ")]), _c('p', {
      staticClass: "mb-1"
    }, [_vm._v(" You have not met the required working hours for this period. ")]), _c('p', {
      staticClass: "mb-1"
    }, [_vm._v(" According to company policy, "), (_violation$rule2 = violation.rule) !== null && _violation$rule2 !== void 0 && (_violation$rule2$data = _violation$rule2.data) !== null && _violation$rule2$data !== void 0 && _violation$rule2$data.min_hours && (_violation$rule3 = violation.rule) !== null && _violation$rule3 !== void 0 && (_violation$rule3$data = _violation$rule3.data) !== null && _violation$rule3$data !== void 0 && _violation$rule3$data.max_hours ? [_vm._v(" you must work at least " + _vm._s(violation.rule.data.min_hours) + " hours and not more than " + _vm._s(violation.rule.data.max_hours) + " hours ")] : (_violation$rule4 = violation.rule) !== null && _violation$rule4 !== void 0 && (_violation$rule4$data = _violation$rule4.data) !== null && _violation$rule4$data !== void 0 && _violation$rule4$data.min_hours ? [_vm._v(" you must work at least " + _vm._s(violation.rule.data.min_hours) + " hours ")] : (_violation$rule5 = violation.rule) !== null && _violation$rule5 !== void 0 && (_violation$rule5$data = _violation$rule5.data) !== null && _violation$rule5$data !== void 0 && _violation$rule5$data.max_hours ? [_vm._v(" you must not work more than " + _vm._s(violation.rule.data.max_hours) + " hours ")] : _vm._e(), _vm._v(" within this " + _vm._s((_violation$rule$data$ = (_violation$rule6 = violation.rule) === null || _violation$rule6 === void 0 ? void 0 : (_violation$rule6$data = _violation$rule6.data) === null || _violation$rule6$data === void 0 ? void 0 : _violation$rule6$data.cycle_in_days) !== null && _violation$rule$data$ !== void 0 ? _violation$rule$data$ : 'N/A') + "-day cycle. ")], 2), _c('p', {
      staticClass: "mb-0"
    }, [_vm._v(" 👉 Please review your schedule and make sure to follow the policy in the upcoming cycles. ")])]);
  })], 2)]) : _vm._e(), _c('day-counted-salary-info', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "payslip": _vm.paySlipData
    }
  }), ((_vm$paySlipData3 = _vm.paySlipData) === null || _vm$paySlipData3 === void 0 ? void 0 : _vm$paySlipData3.salary_type) === 'monthly' ? _c('basic-salary-info', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "payslip": _vm.paySlipData
    }
  }) : _vm._e(), ((_vm$paySlipData4 = _vm.paySlipData) === null || _vm$paySlipData4 === void 0 ? void 0 : _vm$paySlipData4.salary_type) === 'monthly' ? _c('over-time-salary-info', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "payslip": _vm.paySlipData
    },
    on: {
      "append-policy-data": function appendPolicyData($event) {
        return _vm.appendFormData('overtime_policy_id', $event);
      },
      "append-remarks-data": function appendRemarksData($event) {
        return _vm.appendFormData('overtime_remarks', $event);
      },
      "append-isPolicy-data": function appendIsPolicyData($event) {
        return _vm.appendFormData('overtime_is_policy', $event);
      },
      "append-manual-data": function appendManualData($event) {
        return _vm.appendFormData('overtime_manual_amount', $event);
      }
    }
  }) : _vm._e(), _c('project-commission-info', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "payslip": _vm.paySlipData
    },
    on: {
      "append-policy-data": function appendPolicyData($event) {
        return _vm.appendFormData('project_commission_policy_id', $event);
      },
      "append-milestone-data": function appendMilestoneData($event) {
        return _vm.appendFormData('milestone_id', $event);
      },
      "append-remarks-data": function appendRemarksData($event) {
        return _vm.appendFormData('project_commission_remarks', $event);
      },
      "append-isPolicy-data": function appendIsPolicyData($event) {
        return _vm.appendFormData('project_commission_is_policy', $event);
      },
      "append-manual-data": function appendManualData($event) {
        return _vm.appendFormData('project_commission_manual_amount', $event);
      }
    }
  }), _c('k-p-i-commission-info', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "payslip": _vm.paySlipData
    },
    on: {
      "append-data": function appendData($event) {
        return _vm.appendFormData('kpi_amount', $event);
      }
    }
  }), _vm.paySlipData ? _c('festival-bonus-info', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "user": _vm.userData,
      "payslip": _vm.paySlipData
    },
    on: {
      "append-data": function appendData($event) {
        return _vm.appendFormData('festival_bonus_policies', $event);
      }
    }
  }) : _vm._e(), ((_vm$paySlipData5 = _vm.paySlipData) === null || _vm$paySlipData5 === void 0 ? void 0 : _vm$paySlipData5.salary_type) === 'monthly' ? _c('unpaid-leave-info', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "payslip": _vm.paySlipData
    },
    on: {
      "append-fine-data": function appendFineData($event) {
        return _vm.appendFormData('unpaid_leave_fine_amount', $event);
      },
      "append-remarks-data": function appendRemarksData($event) {
        return _vm.appendFormData('unpaid_leave_remarks', $event);
      },
      "append-isManual-data": function appendIsManualData($event) {
        return _vm.appendFormData('unpaid_leave_is_manual', $event);
      },
      "append-manual-data": function appendManualData($event) {
        return _vm.appendFormData('unpaid_leave_manual_amount', $event);
      }
    }
  }) : _vm._e(), ((_vm$paySlipData6 = _vm.paySlipData) === null || _vm$paySlipData6 === void 0 ? void 0 : _vm$paySlipData6.salary_type) === 'monthly' ? _c('extra-leave-info', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "payslip": _vm.paySlipData
    },
    on: {
      "append-fine-data": function appendFineData($event) {
        return _vm.appendFormData('extra_leave_fine_amount', $event);
      },
      "append-remarks-data": function appendRemarksData($event) {
        return _vm.appendFormData('extra_leave_remarks', $event);
      },
      "append-isManual-data": function appendIsManualData($event) {
        return _vm.appendFormData('extra_leave_is_manual', $event);
      },
      "append-manual-data": function appendManualData($event) {
        return _vm.appendFormData('extra_leave_manual_amount', $event);
      }
    }
  }) : _vm._e(), _vm.paySlipData ? _c('others-fine', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "payslip": _vm.paySlipData
    },
    on: {
      "append-data": function appendData($event) {
        return _vm.appendFormData('fine_policies', $event);
      }
    }
  }) : _vm._e(), ((_vm$paySlipData7 = _vm.paySlipData) === null || _vm$paySlipData7 === void 0 ? void 0 : _vm$paySlipData7.salary_type) === 'monthly' ? _c('late-fine-info', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "payslip": _vm.paySlipData
    },
    on: {
      "append-policy-data": function appendPolicyData($event) {
        return _vm.appendFormData('late_fine_policies_id', $event);
      },
      "append-remarks-data": function appendRemarksData($event) {
        return _vm.appendFormData('late_fine_remarks', $event);
      },
      "append-isPolicy-data": function appendIsPolicyData($event) {
        return _vm.appendFormData('late_fine_is_policy', $event);
      },
      "append-manual-data": function appendManualData($event) {
        return _vm.appendFormData('late_fine_manual_amount', $event);
      }
    }
  }) : _vm._e(), _c('meal-info', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "payslip": _vm.paySlipData
    },
    on: {
      "append-policy-data": function appendPolicyData($event) {
        return _vm.appendFormData('meal_policy_id', $event);
      },
      "append-remarks-data": function appendRemarksData($event) {
        return _vm.appendFormData('meal_remarks', $event);
      },
      "append-isPolicy-data": function appendIsPolicyData($event) {
        return _vm.appendFormData('meal_is_policy', $event);
      },
      "append-manual-data": function appendManualData($event) {
        return _vm.appendFormData('meal_manual_amount', $event);
      },
      "append-meal-data": function appendMealData($event) {
        return _vm.appendFormData('meal_amount', $event);
      }
    }
  }), ((_vm$paySlipData8 = _vm.paySlipData) === null || _vm$paySlipData8 === void 0 ? void 0 : _vm$paySlipData8.salary_type) === 'monthly' ? _c('Loan-info', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "payslip": _vm.paySlipData
    }
  }) : _vm._e(), ((_vm$paySlipData9 = _vm.paySlipData) === null || _vm$paySlipData9 === void 0 ? void 0 : _vm$paySlipData9.salary_type) === 'monthly' ? _c('insurance-info', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "payslip": _vm.paySlipData
    }
  }) : _vm._e(), ((_vm$paySlipData10 = _vm.paySlipData) === null || _vm$paySlipData10 === void 0 ? void 0 : _vm$paySlipData10.salary_type) === 'monthly' ? _c('provident-fund-info', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "payslip": _vm.paySlipData
    }
  }) : _vm._e(), ((_vm$paySlipData11 = _vm.paySlipData) === null || _vm$paySlipData11 === void 0 ? void 0 : _vm$paySlipData11.salary_type) === 'monthly' ? _c('income-tax-info', {
    attrs: {
      "currency": _vm.defaultCurrency,
      "payslip": _vm.paySlipData
    },
    on: {
      "append-data": function appendData($event) {
        return _vm.appendFormData('income_tax_amount', $event);
      }
    }
  }) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "mr-1",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.isSubmitting || ((_vm$paySlipData12 = _vm.paySlipData) === null || _vm$paySlipData12 === void 0 ? void 0 : _vm$paySlipData12.status) === 'finally_generated'
    }
  }, [_vm.isSubmitting ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Save ")], 1), _vm.isPayslipPdfGenerating ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 ml-1",
    attrs: {
      "variant": "danger",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), ((_vm$paySlipData13 = _vm.paySlipData) === null || _vm$paySlipData13 === void 0 ? void 0 : _vm$paySlipData13.status) !== 'finally_generated' ? _c('span', [_vm._v("Generating ..")]) : _c('span', [_vm._v("Downloading")])], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.downloadPayslipPDF
    }
  }, [((_vm$paySlipData14 = _vm.paySlipData) === null || _vm$paySlipData14 === void 0 ? void 0 : _vm$paySlipData14.status) !== 'finally_generated' ? _c('span', [_vm._v("Download PDF")]) : _c('span', [_vm._v("Download Payslip")])])]], 2), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('h2', {
    staticClass: "text-capitalize text-right"
  }, [_vm._v(" Total: " + _vm._s(_vm.defaultCurrency) + " " + _vm._s(_vm.totalPayableAmount) + " ")])])], 1)], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }